import React, { Fragment } from "react";
import { getStaticPageLink, constructArtificialLinkNode } from "../../../utils/links";
import Breadcrumb from "../../../components/magnolia/breadcrumb/Breadcrumb";
import HtmlHeader from "../../../components/magnolia/htmlHeader/HtmlHeader";
import LinkWrapper from "../../../components/magnolia/linkWrapper/LinkWrapper";

const NotFound = () => {
    return (
        <Fragment>
            <HtmlHeader title="Not found" />
            <Breadcrumb />

            <div className="error-area pt-40 pb-100">
                <div className="container">
                    <div className="row justify-content-center">
                        <div className="col-xl-7 col-lg-8 text-center">
                            <div className="error">
                                <h1>404</h1>
                                <h2>OPPS! PAGE NOT FOUND</h2>
                                <p>
                                    Sorry but the page you are looking for does not exist, have been removed, name changed or is temporarity
                                    unavailable.
                                </p>
                                <form className="searchform mb-50">
                                    <input
                                        type="text"
                                        name="search"
                                        id="error_search"
                                        placeholder="Search..."
                                        className="searchform__input"
                                    />
                                    <button type="submit" className="searchform__submit">
                                        <i className="fa fa-search" />
                                    </button>
                                </form>

                                <LinkWrapper linkNode={constructArtificialLinkNode({ value: getStaticPageLink("HOME") })}>
                                    Back to home page
                                </LinkWrapper>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </Fragment>
    );
};

export default NotFound;
